<template>
    <el-tabs
        v-model="activeName"
        v-loading="loading"
        :element-loading-text="jzZt"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="height: 100vh;"
    >
        <el-tab-pane label="激活码管理" name="second" style="height: calc(100vh - 60px);padding:0 10px">
            <el-button type="primary"  style=" font-size:12px;height: 30px; padding: 7px 15px;"  @click="jhmdialogVisible = true" >新增激活码</el-button>
            <el-table :data="jhmtableData"  style="width: 100%;margin-top: 10px;height: calc(100vh - 160px);overflow-y:auto">
                <el-table-column
                    prop="activationCode"
                    label="激活码"
                    align="center"
                >
                </el-table-column>
                <el-table-column prop="dwszdbh" align="center" label="单位所在地编号">
                </el-table-column>
                <el-table-column prop="validity" align="center" label="有效时间(天)">
                </el-table-column>
                <el-table-column prop="activation"  align="center" label="状态">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                          <span style="cursor: pointer;color: blue;padding-right: 20px;font-size: 16px;">
                              <el-link type="primary" :underline="false" @click="xgyxq(scope.row)">修改有效期</el-link>
                          </span>
                    </template>
                </el-table-column>
            </el-table>
            <page-footer
                :rForm="form"
                @size-change="sizeChange"
                @current-change="currentChange"
                style="position: absolute;bottom: 10px;right: 2%;"
            ></page-footer>

            <el-dialog
                title="生成激活码"
                :visible.sync="jhmdialogVisible"
                width="50%"
            >
                <el-form :model="jhmruleForm" :rules="jhmrules" ref="jhmruleForm" label-width="140px">
                    <el-form-item label="激活码数量" prop="num">
                        <el-input v-model.number="jhmruleForm.num"></el-input>
                    </el-form-item>
                    <el-form-item label="有效时间(天)" prop="validity">
                        <el-input v-model.number="jhmruleForm.validity"></el-input>
                    </el-form-item>
                    <el-form-item label="单位所在地编号" prop="dwszdbh">
                        <el-input v-model.number="jhmruleForm.dwszdbh"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="jhmclose('jhmruleForm')">取 消</el-button>
                    <el-button type="primary" @click="submitFormjhm('jhmruleForm')">确 定</el-button>
                </span>
            </el-dialog>

            <el-dialog
                title="修改有效期"
                :visible.sync="jhmyxqdialogVisible"
                width="50%"
            >
                <el-form :model="jhmyqxruleForm" :rules="jhmyqxrules" ref="jhmyqxruleForm" label-width="120px">
                    <el-form-item label="激活码">
                        <el-input v-model.number="jhmyqxruleForm.activationCode" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="有效时间(天)" prop="validity">
                        <el-input v-model.number="jhmyqxruleForm.validity"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="jhmclose('jhmyqxruleForm')">取 消</el-button>
                    <el-button type="primary" @click="submityqxFormjhm('jhmyqxruleForm')">确 定</el-button>
                </span>
            </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="客户管理" name="first" style="padding:0 10px">
            <el-button type="primary"  style=" font-size:12px;height: 30px; padding: 7px 15px;"  @click="khdialogVisible = true" >新增客户</el-button>

            <div style="padding-top:10px ">
                <el-table
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column
                        prop="rjCode"
                        label="软件编号"
                        width="300"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="code"
                        label="单位编号"
                        width="180"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="单位名称"
                        width="300"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="单位地址"
                        width="300"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="mcbb"
                        label="初始化版本"
                        width="200"
                        align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            （
                            <!-- <span style="cursor: pointer;color: blue;padding-right: 20px;font-size: 16px;">
                                <el-link type="primary" :underline="false" @click="sjkxxopen(scope.row)">初始化数据库</el-link>
                            </span> -->
                            <el-button slot="reference" type="primary"  style="font-size:12px;height: 30px; padding: 7px 15px;margin-right: 10px;" @click="sjkxxopen(scope.row)">初始化数据库</el-button>
                            <el-popconfirm
                                title="确定下载最新数据库吗？"
                                @confirm="sjkxz(scope.row)"
                                style="height: 30px;"
                            >
                                <el-button slot="reference" type="primary"  style="font-size:12px;height: 30px; padding: 7px 15px;" :disabled="!scope.row.dbAddress">数据库下载</el-button>
                            </el-popconfirm>
                            <!-- <span  style="cursor: pointer;font-size: 16px;">
                                <el-link type="primary" :disabled="!scope.row.dbAddress" :underline="false" @click="sjkxz(scope.row)">数据库下载</el-link>
                            </span> -->
                            ）
                            （
                            <el-popconfirm
                                title="确定上传安装包吗？"
                                @confirm="azbsc(scope.row)"
                                style="height: 30px;"
                            >
                                <el-button slot="reference" type="primary" style="font-size:12px;height: 30px; padding: 7px 15px;">安装包上传</el-button>
                            </el-popconfirm>
                            <!-- <span style="cursor: pointer;color: blue;padding-right: 20px;font-size: 16px;">
                                <el-link type="primary" :underline="false" @click="azbsc(scope.row)">安装包上传</el-link>
                            </span> -->
                            <el-popconfirm
                                title="确定下载安装包吗？"
                                @confirm="azbxz(scope.row)"
                                style="margin-left: 10px;height: 30px;"
                            >
                                <el-button slot="reference" type="primary" style="font-size:12px;height: 30px; padding: 7px 15px;" :disabled="!scope.row.rjAddress">安装包下载</el-button>
                            </el-popconfirm>
                            <!-- <span style="cursor: pointer;color: blue;font-size: 16px;">
                                <el-link type="primary" :disabled="!scope.row.rjAddress" :underline="false" @click="azbxz(scope.row)">安装包下载</el-link>
                            </span> -->
                            ）
                            <el-button slot="reference" type="primary" style="font-size:12px;height: 30px; padding: 7px 15px;margin-left: 10px;" @click="jqxxopen(scope.row)">机器信息</el-button>
                            <!-- <span style="cursor: pointer;color: blue;padding-right: 20px;font-size: 16px;">
                                <el-link type="primary" :underline="false" @click="jqxxopen(scope.row)">机器信息</el-link>
                            </span> -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog
                    :title="sjkxx.rjCode + '-' +sjkxx.name + '（初始化数据库）'"
                    :visible.sync="dialogVisible"
                    v-loading="loading"
                    width="50%"
                    top="10px"
                    @close="zxzxz"
                >
                    <el-form ref="form" :rules="rulesa" :model="formData" label-width="140px">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item prop="rjmc" label="软件名称">
                                    <el-input v-model="formData.rjmc"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="rjws" label="软件位数">
                                    <!-- <el-input v-model="formData.rjws"></el-input> -->
                                    <el-radio v-model="formData.rjws" label="32">32位</el-radio>
                                    <el-radio v-model="formData.rjws" label="64">64位</el-radio>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item prop="dwmc" label="单位名称">
                                    <el-input v-model="formData.dwmc"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="dwszdbh" label="单位所在地编号">
                                    <el-input v-model="formData.dwszdbh"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item prop="xzqjb" label="行政区级别">
                                    <!-- <el-input v-model="formData.xzqjb"></el-input> -->
                                    <el-radio v-model="formData.xzqjb" label="2">师</el-radio>
                                    <el-radio v-model="formData.xzqjb" label="3">县（区）</el-radio>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="dh" label="大号">
                                    <el-input v-model="formData.dh"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item prop="zh" label="中号">
                                    <el-input v-model="formData.zh"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="xh" label="小号">
                                    <el-input v-model="formData.xh"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item prop="mcbb" label="名称版本">
                                    <el-input v-model="formData.mcbb"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="ms" label="软件描述">
                                    <el-input v-model="formData.ms"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item prop="pfdwmc" label="批复单位名称">
                                    <el-input v-model="formData.pfdwmc"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="dedqbh" label="定额地区编号">
                                    <el-input v-model="formData.dedqbh"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="登录界面logo路径">
                                    <el-upload
                                        ref="btUpload"
                                        list-type="picture-card"
                                        :auto-upload="false"
                                        :file-list="fileList"
                                        :action="uploadAction"
                                        :before-upload="beforeAvatarUpload"
                                        :on-change="onImageChange"
                                        :multiple="false"
                                        :on-success="handleUpload"
                                        :on-error="uploadError"
                                    >
                                        <i class="el-icon-plus"></i>
                                        <div slot="file" slot-scope="{file}">
                                            <el-image class="el-upload-list__item-thumbnail" :src="file.url"></el-image>
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="resetForm" style="margin-right: 20px">取 消</el-button>
                        <el-popconfirm
                            title="确定初始化数据库吗？"
                            @confirm="submitForm"
                        >
                            <el-button slot="reference" type="primary">生成</el-button>
                        </el-popconfirm>
                        <!-- <el-button type="primary" @click="submitForm">生成</el-button> -->
                    </span>
                </el-dialog>
                <el-upload ref="uploadB" action="#" :show-file-list="false" :http-request="spimportData" :before-upload="azbbeforeAvatarUpload"></el-upload>
                <el-dialog
                    :title="sjkxx.rjCode + '-' + sjkxx.name + '机器信息'"
                    :visible.sync="jqxxdialogVisible"
                    width="80%"
                    top="10px"
                    @close="jqxxClose"
                >
                    <el-button type="primary"  style=" font-size:12px;height: 30px; padding: 7px 15px;"  @click="xzjqxxopen('jqxxForm')">新增机器信息</el-button>

                    <el-table :data="jqxxtableData" style="height: calc(100vh - 240px);overflow-y: auto;padding-top: 10px">
                        <el-table-column prop="activationCode" label="激活码" width="300" align="center">
                        </el-table-column>
                        <el-table-column prop="machineCode" label="机器码" width="300" align="center">
                        </el-table-column>
                        <!--                        <el-table-column prop="rjCode" label="软件编号" width="180" align="center">-->
                        <!--                        </el-table-column>-->
                        <el-table-column prop="remark" label="机器描述" width="180" align="left">
                        </el-table-column>
                        <el-table-column prop="phone" label="预留手机号" width="120" align="center">
                        </el-table-column>
                        <el-table-column prop="activationTime" label="激活时间" width="180" align="center">
                        </el-table-column>
                        <el-table-column prop="validity" label="有效时间(天)" align="center">
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button slot="reference" type="primary"  style="font-size:12px;height: 30px; padding: 7px 15px;margin-right: 10px;" @click="xgjqxxopen('jqxxForm',scope.row)">修改</el-button>
                            </template>
                        </el-table-column>
<!--                        todo-->
                    </el-table>

                    <el-dialog
                        title="新增机器信息"
                        :visible.sync="xzjqxxdialogVisible"
                        width="50%"
                        append-to-body
                    >
                        <el-form :model="jqxxruleForm" :rules="jqxxrules" ref="jqxxForm" label-width="120px">
                            <!--                            <el-form-item label="激活码" prop="activationCode">
                                                            <el-input v-model="jqxxruleForm.activationCode"></el-input>
                                                        </el-form-item>-->
                            <el-form-item label="选择激活码" prop="activationCode">
                                <el-select v-model="jqxxruleForm.activationCode" placeholder="请选择激活码">
                                    <el-option v-for="item of notActiveList" :key="item.activationCode" :label="item.activationCode" :value="item.activationCode"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="软件大版本号" prop="largeVersion">
                                <el-input v-model.number="jqxxruleForm.largeVersion" :disabled="true"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="xzjqxxClose('jqxxForm')">取 消</el-button>
                            <el-button type="primary" @click="jqxxsubmitForm('jqxxForm')">确 定</el-button>
                        </span>
                    </el-dialog>

                    <el-dialog
                        title="修改机器信息"
                        :visible.sync="xgjqxxdialogVisible"
                        width="50%"
                        append-to-body
                    >
                        <el-form :model="xgjqxxObj" :rules="jqxxrules" ref="jqxxForm" label-width="120px">
                            <!--                            <el-form-item label="激活码" prop="activationCode">
                                                            <el-input v-model="jqxxruleForm.activationCode"></el-input>
                                                        </el-form-item>-->
                            <el-form-item label="激活码" prop="activationCode">
                                <el-input v-model.number="xgjqxxObj.activationCode" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item label="机器码" prop="machineCode">
                                <el-input v-model.number="xgjqxxObj.machineCode" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item label="机器描述" prop="remark">
                                <el-input v-model.number="xgjqxxObj.remark" ></el-input>
                            </el-form-item>
                            <el-form-item label="预留手机号" prop="phone">
                                <el-input v-model.number="xgjqxxObj.phone" ></el-input>
                            </el-form-item>
                            <el-form-item label="激活时间" prop="activationTime">
                                <el-input v-model.number="xgjqxxObj.activationTime" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item label="有效期（天）" prop="validity">
                                <el-input v-model.number="xgjqxxObj.validity" ></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="xgjqxxClose('jqxxForm')">取 消</el-button>
                            <el-button type="primary" @click="jqxxsubmitForm2('jqxxForm')">确 定</el-button>
                        </span>
                    </el-dialog>
                </el-dialog>
            </div>
            <el-dialog
                title="新增客户"
                :visible.sync="khdialogVisible"
                @close="khclose('khruleForm')"
                width="50%"
            >
                <el-form :model="khruleForm" :rules="khrules" ref="khruleForm" label-width="140px">
                    <el-form-item label="单位名称" prop="name">
                        <el-input v-model="khruleForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="单位编码" prop="code">
                        <el-input v-model="khruleForm.code"></el-input>
                    </el-form-item>
                    <el-form-item label="软件编号" prop="rjCode">
                        <el-input v-model="khruleForm.rjCode"></el-input>
                    </el-form-item>
                    <el-form-item label="定额地区编号" prop="dedqbh">
<!--                        <el-input v-model="khruleForm.dedqbh"></el-input>-->
                        <el-select v-model="khruleForm.dedqbh"    style="width: 100%" placeholder="请选择定额地区编号">
                            <el-option
                                v-for="item in dedqoptions"
                                :key="item.code"
                                :label="item.name+':'+item.code"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单位所在地编号" prop="dwszdbh">
                        <el-select
                            v-model="khruleForm.dwszdbh"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入地区名称搜索"
                            :remote-method="remoteMethod"
                            style="width: 100%"
                            :loading="loading">
                            <el-option
                                v-for="item in xzoptions"
                                :key="item.code"
                                :label="item.name+':'+item.code"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单位地址" prop="address">
                        <el-input v-model="khruleForm.address"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="khclose('khruleForm')">取 消</el-button>
                    <el-button type="primary" @click="submitFormkh('khruleForm')">确 定</el-button>
                </span>
            </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="升级管理" name="third">
            <el-table :data="rjTableData" style="width: 100%;margin-top: 10px;height: calc(100vh - 160px);overflow-y:auto">
                <el-table-column
                    prop="rjCode"
                    label="软件编号"
                    align="center"
                    width="200">
                </el-table-column>
                <el-table-column
                    prop="digit"
                    label="位数"
                    align="center"
                    width="200">
                </el-table-column>
                <el-table-column prop="name"  align="center" label="软件名称" width="180">
                </el-table-column>
                <el-table-column prop="largeVersion"  align="center" label="大号" width="180">
                </el-table-column>
                <el-table-column prop="mediumVersion" align="center" label="中号" width="180">
                </el-table-column>
                <el-table-column prop="smallVersion" align="center" label="小号" width="180">
                </el-table-column>
                <el-table-column prop="name" align="center" label="版本名称">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                            <span style="cursor: pointer;color: blue;padding-right: 20px;font-size: 16px;">
                                <el-link type="primary" :underline="false" @click="openHistoryVersion(scope.row)">历史版本</el-link>
                            </span>
                        <span  style="cursor: pointer;font-size: 16px;padding-right: 20px;">
                                <el-link type="primary" :underline="false" @click="openUpdateFileList(scope.row)">升级清单</el-link>
                            </span>
                        <span  style="cursor: pointer;font-size: 16px;">
                                <el-link type="primary" :underline="false" @click="getcxwjdata(scope.row,true)">程序文件</el-link>
                            </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog
                title="程序文件"
                :visible.sync="cxwj"
                v-loading="loading"
                width="50%"
                append-to-body
            >
                <el-upload ref="updateUpload" action="#" :show-file-list="false" :http-request="updateFileUpload" :before-upload="beforeUpdateFileUpload" >
                    <el-button type="primary" :disabled="cxwjisqy">点击上传程序文件</el-button>
                </el-upload>
                <el-tree :data="cxwjdata" ></el-tree>
                <!-- <span slot="footer" class="dialog-footer">
                    <el-button @click="xzjqxxClose('jqxxForm')">取 消</el-button>
                    <el-button type="primary" @click="jqxxsubmitForm('jqxxForm')">确 定</el-button>
                </span> -->
            </el-dialog>
            <el-dialog
                :title="lsbbmxTitle"
                :visible.sync="lsbbMxVisible"
                :close-on-click-modal="false"
            >
                <el-form :model="lsbbMxData" :rules="lsbbrules" ref="bbmxForm" label-width="100px">
                    <el-form-item label="位数" prop="ws">
                        <el-select v-model="lsbbMxData.ws" placeholder="请选择" :disabled="lsbbmxTitle.indexOf('版本明细') > -1">
                            <el-option
                                :label="32"
                                :value="32">
                            </el-option>
                            <el-option
                                :label="64"
                                :value="64">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="大版本" prop="dbb">
                        <el-input v-model.number="lsbbMxData.dbb" :disabled="lsbbmxTitle.indexOf('版本明细') > -1"></el-input>
                    </el-form-item>
                    <el-form-item label="中版本" prop="zbb">
                        <el-input v-model.number="lsbbMxData.zbb" :disabled="lsbbmxTitle.indexOf('版本明细') > -1"></el-input>
                    </el-form-item>
                    <el-form-item label="小版本" prop="xbb">
                        <el-input v-model.number="lsbbMxData.xbb" :disabled="lsbbmxTitle.indexOf('版本明细') > -1"></el-input>
                    </el-form-item>
                    <el-form-item label="版本名称" prop="mc">
                        <el-input v-model.number="lsbbMxData.mc" :disabled="lsbbmxTitle.indexOf('版本明细') > -1"></el-input>
                    </el-form-item>
                    <el-form-item label="版本描述" prop="ms">
                        <el-input  type="textarea" v-model="lsbbMxData.ms"></el-input>
                    </el-form-item>
                    <el-form-item label="更新sql语句" >
                        <el-input v-model="lsbbMxData.updateSql"  type="textarea" :row="3"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="doCancelBbxx">取 消</el-button>
              <el-popconfirm
                  title="确认保存吗？"
                  @confirm="doSaveBbxx"
                  style="margin-left: 10px"
              >
                    <el-button slot="reference" type="primary" >保 存</el-button>
              </el-popconfirm>
            </span>
            </el-dialog>
            <el-dialog
                :title="lsbbTitle"
                :visible.sync="lsbbVisible"
                width="50%"
                @close="onLsbbClose"
                append-to-body
            >
                <el-button type="primary" @click="onBbxz">新增版本</el-button>
                <el-table :data="lsbbTableData" style="width: 100%;margin-top: 10px;overflow-y:auto">
                    <el-table-column
                        prop="digit"
                        label="位数"
                        align="center"
                        width="50">
                    </el-table-column>
                    <el-table-column prop="largeVersion"  align="center" label="大号" width="100">
                    </el-table-column>
                    <el-table-column prop="mediumVersion" align="center" label="中号" width="100">
                    </el-table-column>
                    <el-table-column prop="smallVersion" align="center" label="小号" width="100">
                    </el-table-column>
                    <el-table-column prop="name" align="center" label="版本名称">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span style="cursor: pointer;color: blue;padding-right: 20px;font-size: 16px;">
                              <el-popconfirm
                                  title="确认要设置当前版本为使用版本吗？"
                                  @confirm="onBbsz(scope.row)"
                              >
                                <el-link slot="reference" type="primary" :underline="false" >设置为当前</el-link>
                              </el-popconfirm>
                            </span>
                            <span  style="cursor: pointer;font-size: 16px;padding-right: 20px;">
                                <el-link type="primary" :underline="false" @click="getcxwjdata(scope.row,false);">程序文件</el-link>
                            </span>
                            <span  style="cursor: pointer;font-size: 16px;padding-right: 20px;">
                                <el-link type="primary" :underline="false" @click="onBbxg(scope.row)">修改版本信息</el-link>
                            </span>
                            <span  style="cursor: pointer;font-size: 16px;padding-right: 20px;">
                                  <el-popconfirm
                                      title="确认删除吗？"
                                      @confirm="scsjgllsbb(scope.row)"
                                  >
                                <el-link slot="reference" type="primary" :underline="false" >删除</el-link>
                              </el-popconfirm>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    layout="prev, pager, next"
                    :current-page="lsbbCurrent"
                    @current-change="onLsbbPageChange"
                    :total="lsbbTotal">
                </el-pagination>
            </el-dialog>
            <el-dialog
                title="软件清单"
                :visible.sync="sjqdVisible"
            >
                <div v-for="(item,index) in sjqdList" :key="`qd-${index}`" class="mlgl-rde-item">
                    <div class="mlgl-rde-nr">
                        <el-input class="mlgl-de-value" v-model="item.value"></el-input>
                    </div>
                    <div style="height:28px;">
                        <img src="~@/assets/desc.png" alt="" class="deIcoClass2" @click="minusQdItem(item.id)"/>
                        <img src="~@/assets/dexz.png" alt="" class="deIcoClass2" @click="plusQdItem" v-show="(sjqdList.length -1) ===index "/>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="doCancelRjqd">取 消</el-button>
              <el-popconfirm
                  title="确认保存吗？"
                  @confirm="doSaveRjqd"
                  style="margin-left: 10px"
              >
                    <el-button slot="reference" type="primary" >保 存</el-button>
              </el-popconfirm>
            </span>
            </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="定额管理" name="fourth">
            <el-table :data="degltableData"  style="width: 100%;margin-top: 10px;height: calc(100vh - 160px);overflow-y:auto">
                <el-table-column
                    prop="version"
                    label="数字版本"
                    align="center"
                >
                </el-table-column>
                <el-table-column prop="name" align="center" label="名称">
                </el-table-column>
                <el-table-column prop="apply"  align="center" label="是否使用">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.apply">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                          <span style="cursor: pointer;color: blue;padding-right: 20px;font-size: 16px;">
                              <el-link type="primary" :underline="false" @click="degllsbbhandle(scope.row)">历史版本</el-link>
                          </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog
                :title="degllsbbTitle"
                :visible.sync="degllsbbVisible"
                width="50%"
                @close="onLsbbClose"
                append-to-body
            >
                <el-button type="primary" @click="deglBbxz(false)">新增版本</el-button>
                <el-table :data="degllsbbList"  style="height: calc(100vh - 500px);overflow-y: auto;padding-top: 10px">
                    <el-table-column
                        prop="version"
                        label="数字版本"
                        align="center"
                        width="150">
                    </el-table-column>
                    <el-table-column prop="name" align="center" label="名称">
                    </el-table-column>
                    <el-table-column prop="apply"  align="center" label="是否使用">
                        <template  slot-scope="scope">
                            <span v-if="scope.row.apply">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span style="cursor: pointer;color: blue;padding-right: 20px;font-size: 16px;">
                              <el-popconfirm
                                  title="确认要设置当前版本为使用版本吗？"
                                  @confirm="thdegllsbb(scope.row)"
                              >
                                <el-link slot="reference" type="primary" :underline="false" >设置为当前</el-link>
                              </el-popconfirm>
                            </span>
                            <span  style="cursor: pointer;font-size: 16px;padding-right: 20px;">
                                <el-link type="primary" :underline="false" @click="deglBbxz(scope.row)">修改版本信息</el-link>
                            </span>
                            <span  style="cursor: pointer;font-size: 16px;padding-right: 20px;">
                                  <el-popconfirm
                                      title="确认删除吗？"
                                      @confirm="scdegllsbb(scope.row)"
                                  >
                                <el-link slot="reference" type="primary" :underline="false" >删除</el-link>
                              </el-popconfirm>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="height: 80px">
                    <page-footer
                        :rForm="degllsbbpage"
                        @size-change="degllsbbsizeChange"
                        @current-change="degllsbbcurrentChange"
                        style="position: absolute;bottom: 10px;right: 2%"
                    ></page-footer>
                </div>

            </el-dialog>
            <el-dialog
                :title="degllsbbopenTitle"
                :visible.sync="degllsbbopenVisible"
            >
                <el-form :model="degllsbbopenModel" :rules="degllsbbopenrules" ref="degllsbbopenForm" label-width="100px">
                    <el-form-item label="数字版本" prop="version">
                        <el-input v-model.number="degllsbbopenModel.version"></el-input>
                    </el-form-item>
                    <el-form-item label="定额名称" prop="name">
                        <el-input v-model="degllsbbopenModel.name"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="doCanceldegllsbbopen('degllsbbopenForm')">取 消</el-button>
              <el-popconfirm
                  title="确认保存吗？"
                  @confirm="doSavedegllsbbopen('degllsbbopenForm')"
                  style="margin-left: 10px"
              >
                    <el-button slot="reference" type="primary" >保 存</el-button>
              </el-popconfirm>
            </span>
            </el-dialog>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
import PageFooter from "@/components/pageFooter.vue";
import {baseHost} from '@/utils/config'
import CryptoJS from '@/utils/decrypt';

export default {
    name: "gl",
    components: {PageFooter},
    data() {
        return{
            //客户管理
            khdialogVisible:false,
            khruleForm:{
                name:'',
                code:'',
                rjCode:'',
                dedqbh:'',
                dwszdbh:'',
                address:'',
            },
            khrules:{
                name: [
                    { required: true, message: '请输入单位名称' },
                ],
                code: [
                    { required: true, message: '请输入单位编码' },
                ],
                rjCode: [
                    { required: true, message: '请输入软件编号' },
                ],
                address: [
                    { required: true, message: '请输入单位地址' },
                ],
                dedqbh: [
                    { required: true, message: '请选择定额地区编号' },
                ],
                dwszdbh: [
                    { required: true, message: '请选择单位所在地编号' },
                ],
            },
            xzoptions:[],
            dedqoptions:[],

            defaultimg:[{
                url:''
            }],

            sjqdIndex: 0,
            sjqdVisible: false,
            sjqdList:[],
            lsbbmxTitle: '历史版本',
            lsbbTitle: '历史版本',
            lsbbQuery:{
                largeVersion: 0,
                rjCode: '',
                id:null
            },
            lsbbCurrent: 1,
            lsbbTotal: 0,
            lsbbVisible: false,
            lsbbTableData: [],
            lsbbMxVisible: false,
            lsbbMxData: [],
            cxwj:false,
            cxwjisqy:true,
            cxwjdata:[],
            loading:false,
            jzZt:'',
            dialogVisibleyl: true,
            fileList:[],
            //uploadAction: 'http://192.168.0.135:9507/ysdes/s-file/v1/uploadFile',
            uploadAction: baseHost+'/s-file/v1/uploadFile',
            tableData: [],
            dialogVisible:false,
            dialogImageUrl:'',
            sjkxx:{},
            azbxx:{},
            activeName: 'second',
            formData:{
                id:'',
                rjmc:'',
                rjws:'64',
                dwmc:'',
                dwszdbh:'',
                xzqjb:'',
                dh:'',
                zh:'',
                xh:'',
                mcbb:'',
                ms:'',
                logolj:'',
                dedqbh:'',
                pfdwmc:'',
            },
            rulesa: {
                rjmc: [
                    { required: true, message: '请输入软件名称', trigger: 'blur' },
                ],
                rjws: [
                    { required: true, message: '请选择软件位数', trigger: 'blur' }
                ],
                dwmc: [
                    { required: true, message: '请输入单位名称', trigger: 'blur' },
                ],
                dwszdbh: [
                    { required: true, message: '请输入单位所在地编号', trigger: 'blur' },
                ],
                xzqjb: [
                    { required: true, message: '请输入行政区级别', trigger: 'blur' },
                ],
                dh: [
                    { required: true, message: '请选择大号', trigger: 'blur' }
                ],
                zh: [
                    { required: true, message: '请选择中号', trigger: 'blur' }
                ],
                xh: [
                    { required: true, message: '请选择小号', trigger: 'blur' }
                ],
                mcbb: [
                    { required: true, message: '请填写名称版本', trigger: 'blur' }
                ],
                ms: [
                    { required: true, message: '请填写软件描述', trigger: 'blur' }
                ],
                logolj: [
                    { required: true, message: '请填写登录界面logo路径', trigger: 'blur' }
                ],
                dedqbh: [
                    { required: true, message: '请填写定额地区编号', trigger: 'blur' }
                ],
                pfdwmc: [
                    { required: true, message: '请填写批复单位名称', trigger: 'blur' }
                ],
            },

            //激活码
            form: {
                size: 10,
                current: 1,
                total: 0,
            },
            jhmtableData:[],
            jhmdialogVisible:false,
            jhmyxqdialogVisible:false,
            jhmruleForm:{
                num:'',
                validity:'',
            },
            jhmyqxruleForm:{
                id:"",
                activationCode:'',
                activation:'',
                validity:'',
            },
            jhmrules:{
                num: [
                    { required: true, message: '请输入生成激活码数量' },
                    { type: 'number',min:1, message: '激活码数量必须为数字值'}
                ],
                validity: [
                    { required: true, message: '请输入有效时间' },
                    { type: 'number',min:1, message: '有效时间必须为数字值'}
                ],
                dwszdbh: [
                    { required: true, message: '请输入单位所在地编号' },
                ],
            },
            jhmyqxrules:{
                validity: [
                    { required: true, message: '请输入有效时间' },
                    { type: 'number',min:1, message: '有效时间必须为数字值'}
                ],
            },
            //机器信息
            dwxxid:null,
            jqxxtableData:[],
            jqxxdialogVisible:false,
            xzjqxxdialogVisible:false,
            xgjqxxdialogVisible:false,
            xgjqxxObj:{},
            jqxxruleForm:{
                activationCode:'',
                largeVersion:'',
                user:null,
                rjCode:'',
                dwszdbh:''
            },
            jqxxrules:{
                activationCode: [
                    { required: true, message: '请选择激活码' },
                ],
                largeVersion: [
                    { required: true, message: '请输入软件大版本号' },
                    { type: 'number',min:1, message: '软件大版本号必须为数字值'}
                ],
            },
            notActiveList:[],
            //软件升级
            rjTableData:[],
            lsbbrules: {
                dbb: [
                    { required: true, message: '请输入软件大版本' },
                    { type: 'number',min:1,max:99, message: '软件大版本在1~99之间'}
                ],
                zbb: [
                    { required: true, message: '请输入软件中版本' },
                    { type: 'number',min:0,max:99, message: '软件中版本在0~99之间'}
                ],
                xbb: [
                    { required: true, message: '请输入软件小版本' },
                    { type: 'number',min:0,max:99, message: '软件小版本在0~99之间'}
                ],
                ws: [{required: true,message: '请选择软件位数', trigger: 'blur'}],
                mc: [{required: true,message: '请输入软件名称', trigger: 'blur'}],
                ms: [{required: true,message: '请输入软件描述', trigger: 'blur'}],
            },
            //定额管理
            degltableData:[],
            degllsbbVisible:false,
            degllsbbTitle:'',
            degllsbbList:[],
            degllsbbpage: {
                size: 10,
                current: 1,
                total: 0,
            },
            //定额管理历史版本open
            degllsbbopenTitle:'',
            degllsbbopenVisible:false,
            degllsbbopenModel:{
                version:'',
                name:'',
            },
            degllsbbopenrules: {
                version: [
                    { required: true, message: '请输入数字版本' },
                    { type: 'number',min:1, message: '激活码数量必须为数字值'}
                ],
                name: [
                    {required: true, message: '请输入版本名称'}
                ],
            },

        }
    },
    mounted() {
        this.getlist()
        this.getjhmlist();
        this.getsjlist();
        this.getdegllist();
        this.getdedqlist();
    },
    methods: {
        getdedqlist() {
            this.request.get("/s-admindiv/v1/query/pro").then((res) => {
                if (res.ok) {
                    this.dedqoptions = res.data
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },

        remoteMethod(query){
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                   this.getXzList(query)
                }, 200);
            } else {
                this.xzoptions = [];
            }
        },
        getXzList(query){
            let params = {
                name: query
            }
            this.request.get("/s-admindiv/v1/query",{params:params}).then((res) => {
                if (res.ok) {
                    this.xzoptions = res.data
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        thdegllsbb(row){
            this.request.put("/s-desjbb/v1/"+row.id).then((res) => {
                if (res.ok) {
                    this.$message.success('替换成功！');
                    this.getdegllist()
                    this.getdegllsbbhlist();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        scdegllsbb(row){
            this.request.delete("/s-desjbb/v1/"+row.id).then((res) => {
                if (res.ok) {
                    this.$message.success('删除成功！');
                    this.getdegllsbbhlist();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        //定额数据版本管理
        getdegllist(){
            this.request.get("/s-desjbb/v1/queryApply").then((res) => {
                if (res.ok) {
                    this.$set( this.degltableData,0, res.data)
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        degllsbbhandle(row){
            this.degllsbbTitle = row.name+'历史版本';
           this.getdegllsbbhlist();

        },
        getdegllsbbhlist(){
            this.request.get("/s-desjbb/v1/pageList",{params: this.degllsbbpage}).then((res) => {
                if (res.ok) {
                    this.degllsbbList = res.data.records;
                    this.degllsbbpage.total = res.data.total;
                    this.degllsbbVisible = true;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        deglBbxz(row){
            //
            this.degllsbbopenVisible = true;
            if(!row){
                this.degllsbbopenTitle = '新增定额数据版本'
                this.degllsbbopenModel = {

                }
            }else{
                this.degllsbbopenTitle = '修改定额数据版本'
                this.degllsbbopenModel = JSON.parse(JSON.stringify(row))
            }
            this.clear('degllsbbopenForm')
        },
        doSavedegllsbbopen(formName){
            if( this.degllsbbopenTitle === '新增定额数据版本'){
                this.request.post("/s-desjbb/v1 ", this.degllsbbopenModel).then((res) => {
                    if (res.ok) {
                        this.$message.success('新增成功！');
                        this.degllsbbopenVisible = false;
                        this.getdegllsbbhlist();
                    } else {
                        this.degllsbbopenVisible = false;
                        this.$message.error(res.error.message);
                    }
                });
            }else{
                this.request.put("/s-desjbb/v1 ", this.degllsbbopenModel).then((res) => {
                    if (res.ok) {
                        this.$message.success('修改成功！');
                        this.degllsbbopenVisible = false;
                        this.getdegllsbbhlist();
                    } else {
                        this.degllsbbopenVisible = false;
                        this.$message.error(res.error.message);
                    }

                });
            }
            //this.clear(formName)
        },
        doCanceldegllsbbopen(formName){
            this.degllsbbopenVisible = false;
        },
        degllsbbsizeChange(val){
            this.degllsbbpage.size = val;
            this.getdegllsbbhlist();
        },
        // 切换分页
        degllsbbcurrentChange(val) {
            this.degllsbbpage.current = val;
            this.getdegllsbbhlist();
        },



        xgyxq(row){
            this.jhmyqxruleForm = row;
            this.jhmyxqdialogVisible = true
        },
        doCancelRjqd(){
            this.lsbbQuery.id = "";
            this.lsbbQuery.rjCode = "";
            this.sjqdIndex = 0;
            this.sjqdList = [];
            this.sjqdVisible = false;
        },
        doSaveRjqd(){
            const datas = this.sjqdList;
            // if(datas.length > 0){
            const uploadDatas = [];
            datas.forEach(n=>{
                uploadDatas.push(n.value);
            })
            const updateJsonData = JSON.stringify(uploadDatas);
            const parmas = {id: this.lsbbQuery.id,rjbb: this.lsbbQuery.rjCode,wjmc: updateJsonData};
            this.request.put('/s-wjqd/v1',parmas).then(res=>{
                if(res.ok){
                    this.$message.success('保存成功！');
                    this.doCancelRjqd();
                }else {
                    this.$message.error(res.error.message);
                }
            })
            // }else {
            //   this.$message.error('数据清单至少要有一条数据！');
            // }
        },
        minusQdItem(id){
            this.sjqdList = this.sjqdList.filter(n => n.id!== id);
        },
        plusQdItem(){
            const tmpIndex = this.sjqdIndex + 1;
            const tmp = {value: '',id: tmpIndex};
            this.sjqdIndex = tmpIndex;
            this.sjqdList.push(tmp);
        },
        beforeUpdateFileUpload(file){
            const fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1);
            const extension = fileExtension === "zip";
            if (!extension) {
                this.$message({message: "只能上传是zip格式!",type: "warning"});
                return false;
            }
            return extension ;
        },

        updateFileUpload(file){
            let that = this;
            const fd = new FormData(); //参数的格式是formData格式的
            fd.append("file", file.file); //参数
            fd.append("id", this.lsbbQuery.id); //参数
            this.jzZt = '上传中';
            this.loading = true;
            this.request.post("/s-file/v1/softwareUpdate", fd).then((res) => {
                if (res.ok) {
                    this.$message.success('上传成功！');
                    this.loading = false;
                    const rowData = {id: this.lsbbQuery.id};
                    this.getcxwjdata(rowData);
                } else {
                    this.loading = false;
                    this.$message.error(res.error.message);
                }
            });
        },
        onLsbbClose(){
            this.lsbbTitle = '';
            this.lsbbTableData = [];
            this.lsbbQuery = {largeVersion: 0,
                rjCode: ''};
            this.getsjlist();
            this.lsbbVisible = false;
        },
        doCancelBbxx(){
            this.lsbbMxVisible = false;
            this.lsbbmxTitle = '';
            this.lsbbMxData = {};
        },
        doSaveBbxx(){
            this.$refs.bbmxForm.validate((valid) => {
                if(valid){
                    const params = {
                        id: this.lsbbMxData.id,
                        rjCode : this.lsbbQuery.rjCode,
                        digit: this.lsbbMxData.ws,
                        largeVersion: this.lsbbMxData.dbb,
                        mediumVersion: this.lsbbMxData.zbb,
                        smallVersion: this.lsbbMxData.xbb,
                        name: this.lsbbMxData.mc,
                        apply: 0,
                        remark: this.lsbbMxData.ms,
                        address: this.lsbbMxData.dz,
                        updateSql: this.lsbbMxData.updateSql
                    }
                    if(this.lsbbmxTitle == this.lsbbQuery.rjCode+'版本新增'){
                        this.request.post("/upgrade/v1/saveVersionInfo", params).then((res) => {
                            if(res.ok){
                                this.$message.success('保存成功！');
                                const data = {rjCode: this.lsbbQuery.rjCode,largeVersion:this.lsbbMxData.dbb};
                                this.openHistoryVersion(data);
                            }else {
                                this.$message.error(res.error.message);
                            }
                            this.doCancelBbxx();
                        })
                    }else{
                        this.request.put("/upgrade/v1",params).then((res) => {
                            if(res.ok){
                                this.$message.success('修改成功！');
                                const data = {rjCode: this.lsbbQuery.rjCode,largeVersion:this.lsbbMxData.dbb};
                                this.openHistoryVersion(data);
                            }else {
                                this.$message.error(res.error.message);
                            }
                            this.doCancelBbxx();
                        })
                    }

                }
            })
        },
        onBbxz(){
            this.clear('bbmxForm')
            this.lsbbmxTitle = this.lsbbQuery.rjCode+'版本新增';
            this.lsbbMxVisible = true;
            // this.lsbbMxData = {dbb:this.lsbbQuery.largeVersion};
            this.lsbbMxData = {};
        },
        onBbxg(row){
            console.log('row',row)
            this.lsbbmxTitle = '('+this.lsbbQuery.rjCode+')'+row.name+'版本明细';
            this.lsbbMxVisible = true;
            this.lsbbMxData = {
                id: row.id,
                ws:row.digit,
                dbb:row.largeVersion,
                zbb:row.mediumVersion,
                xbb:row.smallVersion,
                mc:row.name,
                ms:row.remark,
                dz:row.address,
                updateSql: row.updateSql
            }
        },
        onBbsz(row){
            // const header = {'rjCode':rjCode}
            const params = {id: row.id};
            this.request.post("/upgrade/v1/setUseVersion", params).then((res) => {
                if (res.ok) {
                    this.$message.success("设置成功！");
                    const data = {rjCode: this.lsbbQuery.rjCode,largeVersion:row.largeVersion};
                    this.openHistoryVersion(data)
                    this.getsjlist()
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        scsjgllsbb(row){
            this.request.delete("/upgrade/v1/"+row.id).then((res) => {
                if (res.ok) {
                    this.$message.success('删除成功！');
                    const data = {rjCode: this.lsbbQuery.rjCode,largeVersion:row.largeVersion};
                    this.openHistoryVersion(data)
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        onLsbbPageChange(page){
            const params = {...this.lsbbQuery,current: page};
            this.request.get("/upgrade/v1/pageList",{params: params}).then((res) => {
                if (res.ok) {
                    this.lsbbVisible = true;
                    this.lsbbTableData = res.data.records;
                    this.lsbbTotal = res.data.total;
                    this.lsbbCurrent = res.data.current;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        openHistoryVersion(row){
            const version = row.largeVersion;
            if(version) {
                this.lsbbQuery ={
                    largeVersion : version,
                    rjCode : row.rjCode
                }
                this.lsbbTitle = row.rjCode+'历史版本';
                const params = {
                    largeVersion: version,
                    rjCode: row.rjCode,
                    current: 1
                }
                this.request.get("/upgrade/v1/pageList?",{params: params}).then((res) => {
                    if (res.ok) {
                        if(!this.lsbbVisible) {
                            this.lsbbVisible = true;
                        }
                        this.lsbbTableData = res.data.records;
                        this.lsbbTotal = res.data.total;
                        this.lsbbCurrent = res.data.current;
                    } else {
                        this.$message.error(res.error.message);
                    }
                });
            }else {
                this.$message.error('未获取到版本信息！');
            }
        },
        openUpdateFileList(row){
            const version = row.largeVersion;
            this.request.get('/s-wjqd/v1/getInfo',{params:{rjbb: version}}).then(res=>{
                if (res.ok){
                    let tmpData = '';
                    this.lsbbQuery.id = res.data.id;
                    this.lsbbQuery.rjCode = res.data.rjbb;
                    try {
                        tmpData = JSON.parse(res.data.wjmc)
                    }catch (e) {
                        this.$message.warning('数据解析错误！');
                        return;
                    }
                    const datas = [];
                    tmpData.forEach((n,index) => {
                        const tmp = {value: n,id: index};
                        datas.push(tmp);
                    })
                    this.sjqdIndex = datas.length;
                    this.sjqdList = datas;
                    this.sjqdVisible = true;
                }else {
                    this.$message.warning(res.error.message);
                }

            })
        },
        xzjqxxopen(formName){
            this.xzjqxxdialogVisible = true
            this.cxnotActiveList()
            this.clear(formName)
        },
        xgjqxxopen(formName,row){
            this.xgjqxxdialogVisible = true
            this.xgjqxxObj = row
            this.cxnotActiveList()
            this.clear(formName)
        },
        cxnotActiveList(row){
            this.request.get('/s-jhm/v1/not-active/list?dwszdbh='+this.jqxxruleForm.dwszdbh).then((res) => {
                if (res.ok) {
                    this.notActiveList = res.data
                } else {
                    this.$message.error(res.error.message);
                }

            })
        },
        jqxxopen(row){
            this.jqxxdialogVisible = true;
            this.searchjqxx(row.id);
            this.sjkxx.rjCode = row.rjCode;
            this.sjkxx.name = row.name;
            this.jqxxruleForm.user = row.id
            this.jqxxruleForm.largeVersion = row.largeVersion
            this.jqxxruleForm.rjCode = row.rjCode
            this.jqxxruleForm.dwszdbh = row.dwszdbh
        },
        searchjqxx(id){
            id ? this.dwxxid = id  : null
            const data = {
                user: this.dwxxid
            }
            this.request.get('/s-jqxx/v1/list',{ params:data }).then((res) => {
                if (res.ok) {
                    this.jqxxtableData = res.data
                } else {
                    this.$message.error(res.error.message);
                }

            })
        },
        jqxxClose(){
            this.jqxxdialogVisible = false;
        },
        xzjqxxClose(formName){
            this.xzjqxxdialogVisible = false;
            this.clear(formName)
        },
        xgjqxxClose(formName){
            this.xgjqxxdialogVisible = false;
            this.clear(formName)
        },
        jqxxsubmitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // const tjData = {
                    //     ...this.jqxxForm,

                    // }
                    let jqm = CryptoJS.encrypt(this.jqxxruleForm.activationCode)
                    this.jqxxruleForm.machineCode = jqm
                    this.request.post("/s-jqxx/v1",this.jqxxruleForm).then((res) => {
                        if (res.ok) {
                            this.searchjqxx()
                            this.$message.success("新增机器信息成功！")
                        } else {
                            this.$message.error(res.error.message);
                        }
                    });
                    this.xzjqxxdialogVisible = false
                    this.clear(formName)
                } else {
                    return false;
                }
            });
        },
        jqxxsubmitForm2(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // const tjData = {
                    //     ...this.jqxxForm,

                    // }
                    console.log('this.xgjqxxObj',this.xgjqxxObj)
                    this.request.put("/s-jqxx/v1",this.xgjqxxObj).then((res) => {
                        if(res.ok){
                            this.searchjqxx()
                            this.$message.success("修改机器信息成功！")
                        }else {
                            this.$message.error(res.error.message);
                        }
                        this.doCancelBbxx();
                    })

                    this.xgjqxxdialogVisible = false
                    this.clear(formName)
                } else {
                    return false;
                }
            });
        },
        azbsc(row){
            this.azbxx.id = row.id;
            this.$refs['uploadB'].$refs['upload-inner'].handleClick();
        },
        spimportData(obj) {
            let fd = new FormData(); //参数的格式是formData格式的
            fd.append("file", obj.file); //参数
            fd.append("companyId", this.azbxx.id); //参数
            this.jzZt = '上传中';
            this.loading = true;
            this.request.post("/s-file/v1/uploadFile/rj", fd,).then((res) => {
                if (res.ok) {
                    this.$message.success('上传成功！');
                    this.loading = false;
                    this.getlist();
                    // let params = {
                    //     id:this.azbxx.id,
                    //     rjName:obj.file.name,
                    //     rjAddress:res.data
                    // }
                    // this.request.put("/s-company/v1/modify/rjAddress", params).then((res) => {
                    //     if (res.ok) {
                    //         this.$message.success('上传成功！');
                    //         this.loading = false;
                    //         this.getlist();
                    //     } else {
                    //         this.$message.error(res.error.message);
                    //     }
                    // });
                } else {
                    this.loading = false;
                    this.$message.error(res.error.message);
                }
            });
        },
        azbbeforeAvatarUpload(file) {
            this.scwjgs = file.name.substring(file.name.lastIndexOf(".") + 1);
            const extension = this.scwjgs === "exe";
            const extension2 = this.scwjgs === "msi";
            const extension3 = this.scwjgs === "appx";
            const extension4 = this.scwjgs === "msix";
            if (!extension && !extension2 && !extension3 && !extension4) {
                this.$message({message: "只能上传是exe、msi、appx、msix格式!",type: "warning"});
                return false;
            }
            return extension || extension2 || extension3 || extension4;
        },
        azbxz(row){
            const data = {
                companyId:row.id,
            }
            this.jzZt = '获取资源中';
            this.loading = true;
            this.request.get('/s-file/v1/download/rj',{ params: data,responseType: "blob" }).then((res) => {
                try {
                    let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const a = document.createElement("a");
                    a.href = URL.createObjectURL(blob);
                    // 这里填保存成的文件名
                    a.download = row.name + row.mcbb + '-setup.exe';
                    a.click();
                    URL.revokeObjectURL(a.href);
                    this.loading = false;
                    return;
                } catch (error) {
                    const reader = new FileReader();
                    reader.readAsText(res.data, 'utf-8');
                    let _this = this;
                    reader.onload=function(){
                        const msg = JSON.parse(reader.result);
                        if (!msg.ok) {
                            this.loading = false;
                            if (msg.error.code == 3001) {
                                _this.$message.error(msg.error.message);
                            } else {
                                _this.$message.warning(msg.error.message);
                            }
                        }
                    }
                }
            });
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg'|| file.type === 'image/png';
            if (!isJPG) {
                this.$message.error('只能上传图片!');
            }
            return isJPG;
        },
        onImageChange(files,fileLists){
            if(this.fileList.length > 0){
                const fileArray = [];
                fileArray.push(files);
                this.fileList = fileArray;
            }else {
                this.fileList = fileLists;
            }
            this.$refs.btUpload.submit();
        },
        handleUpload(res){
            if(res.ok) {
                this.formData.logolj = res.data;
                this.request.get("/s-file/v1/img/"+res.data).then((res) => {
                    if (res.ok) {
                        const blob = new Blob([res.data]);
                        this.changeImageToBase64(blob, (base64Url) => {
                            this.fileList = [{url: base64Url}];
                        });
                    } else {
                        this.$message.error(res.error.message);
                    }
                });
            }else{
                this.uploadError();
            }
        },
        changeImageToBase64(blob, callback) {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function (e) {
                callback(e.target.result);
            };
        },
        uploadError(){
            this.$message.error('上传失败！');
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl =  file.url;
            this.dialogVisibleyl = true;
        },
        getlist(){
            this.request.get("/s-company/v1/pageList").then((res) => {
                if (res.ok) {
                    this.tableData = res.data.records
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        sjkxxopen(row){
            this.fileList = []
            this.dialogVisible = true
            this.sjkxx.rjCode = row.rjCode;
            this.sjkxx.name = row.name;
            this.sjkxx.id = row.id
            this.formData.rjmc = '计划用水综合管理平台'
            this.formData.dwmc = this.sjkxx.name
            this.formData.dedqbh = row.dedqbh
            this.formData.dwszdbh = row.dwszdbh
            this.formData.pfdwmc =  '新疆生产建设兵团第XX师水文水资源管理中心'
        },
        submitForm() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.formData.id = this.sjkxx.id;
                    this.jzZt = '生成中';
                    this.loading = true;
                    this.request.put("/s-company/v1/build",this.formData).then((res) => {
                        if (res.ok) {
                            this.loading = false;
                            this.dialogVisible = false;
                            this.$message.success('生成成功！');
                        } else {
                            this.loading = false;
                            this.$message.error(res.error.message);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm() {
            this.dialogVisible = false;
            this.formData = {
                id:'',
                rjmc:'',
                rjws:'64',
                dwmc:'',
                dwszdbh:'',
                xzqjb:'',
                dh:'',
                zh:'',
                xh:'',
                mcbb:'',
                ms:'',
                logolj:'',
                dedqbh:'',
                pfdwmc:'',
            }
            this.$refs['form'].resetFields();
        },
        zxzxz(){
            this.resetForm();
            this.getlist();
        },
        sjkxz(row){
            const data = {
                companyId:row.id,
            }
            this.request.get('/s-file/v1/download/db',{ params: data,responseType: "blob" }).then((res) => {
                try {
                    let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const a = document.createElement("a");
                    a.href = URL.createObjectURL(blob);
                    // 这里填保存成的文件名
                    a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
                    a.click();
                    URL.revokeObjectURL(a.href);
                    return;
                } catch (error) {
                    const reader = new FileReader();
                    reader.readAsText(res.data, 'utf-8');
                    let _this = this;
                    reader.onload=function(){
                        const msg = JSON.parse(reader.result);
                        if (!msg.ok) {
                            if (msg.error.code == 3001) {
                                _this.$message.error(msg.error.message);
                            } else {
                                _this.$message.warning(msg.error.message);
                            }
                        }
                    }
                }
            });
        },

        getjhmlist(){
            this.request.get("/s-jhm/v1/pageList",{params:this.form}).then((res) => {
                if (res.ok) {
                    this.jhmtableData = res.data.records;
                    this.form.total = res.data.total;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        sizeChange(val){
            this.form.size = val;
            this.getjhmlist();
        },
        // 切换分页
        currentChange(val) {
            this.form.current = val;
            this.getjhmlist();
        },
        //
        submitFormjhm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.request.post("/s-jhm/v1",this.jhmruleForm).then((res) => {
                        if (res.ok) {
                            this.getjhmlist()
                            this.$message.success("生成激活码成功！")
                        } else {
                            this.$message.error(res.error.message);
                        }
                    });
                } else {
                    return false;
                }
            });
            this.jhmdialogVisible = false
            this.clear(formName)
        },
        submityqxFormjhm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.request.put("/s-jhm/v1",this.jhmyqxruleForm).then((res) => {
                        if (res.ok) {
                            this.getjhmlist()
                            this.$message.success("修改激活码有效期成功！")
                        } else {
                            this.$message.error(res.error.message);
                        }
                    });
                } else {
                    return false;
                }
            });
            this.jhmyxqdialogVisible = false
            this.clear(formName)
        },
        khclose(formName){
            this.khdialogVisible = false;
            this.clear(formName)
        },
        submitFormkh(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.request.post("/s-company/v1",this.khruleForm).then((res) => {
                        if (res.ok) {
                            this.getlist()
                            this.$message.success("新增客户成功！")
                        } else {
                            this.$message.error(res.error.message);
                        }
                    });
                } else {
                    return false;
                }
                this.khdialogVisible = false
                this.clear(formName)
            });

        },
        jhmclose(formName){
            this.jhmdialogVisible = false;
            this.jhmyxqdialogVisible = false;
            this.clear(formName)
        },
        clear(formName){
            if(this.$refs[formName] !== undefined){
                this.$refs[formName].clearValidate();
                this.$refs[formName].resetFields();
            }
        },

        getsjlist(){
            this.request.get("/upgrade/v1/list").then((res) => {
                if (res.ok) {
                    this.rjTableData = res.data
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        getcxwjdata(row,flag){
            this.cxwjisqy=flag
            this.lsbbQuery.id = row.id;
            this.request.get("/upgrade/v1/tree/"+row.id).then((res) => {
                if (res.ok) {
                    this.cxwj = true;
                    this.cxwjdata = res.data;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        getsjqddata(row){
            this.request.get("/s-wjqd/v1/pageList"+row.id).then((res) => {
                if (res.ok) {
                    this.cxwj = true;

                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
    },
}
</script>
<style scoped>
.zxcv{
    color: green;
}
::v-deep .el-divider__text, .el-link {
    font-size: 17px;
}
.deIcoClass2 {
    width: 14px;
    height: 14px;
    padding: 7px;
    margin-left: 5px;
    cursor: pointer;
}
.mlgl-rde-nr {
    width: 80%;
    background-color: #ffffff;
    border-radius: 1px;
    border: solid 1px #cecece;
}
.mlgl-rde-item{
    width: 100%;
    display: flex;
    justify-content: flex-start;
}
</style>

